import { render, staticRenderFns } from "./manuscriptIndex.vue?vue&type=template&id=5700c609&scoped=true"
import script from "./manuscriptIndex.vue?vue&type=script&lang=js"
export * from "./manuscriptIndex.vue?vue&type=script&lang=js"
import style0 from "./manuscriptIndex.vue?vue&type=style&index=0&id=5700c609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700c609",
  null
  
)

export default component.exports